import styled, { keyframes } from 'styled-components';

import { buildPalette } from '../../theme/palette';

const shimmer = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

const dashboardPalette = buildPalette({
  light: {
    card: '#ffffff',
    border: '#e8e8e8',
    base: '#f2f2f2',
    mid: '#e6e6e6',
  },
  dark: {
    card: '#1f1f1f',
    border: '#3a3a3a',
    base: '#2b2b2b',
    mid: '#3c3c3c',
  },
});

export interface SkeletonBlockProps {
  height?: string;
  width?: string;
  radius?: string;
}

export const SkeletonBlock = styled.div<SkeletonBlockProps>`
  height: ${(props) => props.height ?? '14px'};
  width: ${(props) => props.width ?? '100%'};
  border-radius: ${(props) => props.radius ?? '8px'};
  background: linear-gradient(
    90deg,
    ${dashboardPalette('base')} 25%,
    ${dashboardPalette('mid')} 37%,
    ${dashboardPalette('base')} 63%
  );
  background-size: 400% 100%;
  animation: ${shimmer} 1.2s ease-in-out infinite;
`;

export const TabsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const ListCard = styled.div`
  background: ${dashboardPalette('card')};
  border: 1px solid ${dashboardPalette('border')};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
`;

export const PillRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const MapShell = styled.div`
  flex: 1;
  min-height: 500px;
  height: 100%;
  border: 1px solid ${dashboardPalette('border')};
  border-radius: 12px;
  overflow: hidden;
`;

export const MapSkeleton = styled(SkeletonBlock)`
  height: 100%;
  min-height: 500px;
  border-radius: 12px;
`;
